import React, { useEffect, useState } from "react";
import Typed from "typed.js";
import "../header.css"; 
import profile from "../images/profile.jpeg";

const Header = () => {
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const typed = new Typed("#typed-text", {
      strings: ["Shoaib's Portfolio"],
      typeSpeed: 70,
      backSpeed: 40,
      loop: true,
      showCursor: false,
    });

    return () => typed.destroy();
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const nav = document.querySelector("nav");
      if (window.scrollY > 100) {
        nav.classList.add("nav-scrolled");
      } else {
        nav.classList.remove("nav-scrolled");
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleProfileCard = () => {
    setIsProfileOpen((prev) => !prev);
  };

  const toggleMobileNav = () => {
    setIsMobileMenuOpen((prev) => !prev);
  };

  const closeMobileNav = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <nav>
      <div className="left">
        <span id="typed-text"></span>
      </div>

      <div className={`right ${isMobileMenuOpen ? "active" : ""}`} id="nav-menu">
        <ul>
          <li><a href="#shoaib" onClick={closeMobileNav}>Home</a></li>
          <li><a href="#about" onClick={closeMobileNav}>About</a></li>
          <li><a href="#passion" onClick={closeMobileNav}>Passion</a></li>
          <li><a href="#skills" onClick={closeMobileNav}>Skills</a></li>
          <li><a href="#projects" onClick={closeMobileNav}>Projects</a></li>
          <li><a href="#contact" onClick={closeMobileNav}>Contact Me</a></li>
          <li>
            <a 
              href="https://drive.google.com/file/d/1G4gxQT7tGXabRIdWJuWfWQovFvMZuGOV/view?usp=drivesdk" 
              target="_blank" 
              rel="noopener noreferrer" 
              onClick={closeMobileNav}
            >
              Resume
            </a>
          </li>
        </ul>
      </div>

      <div
        className={`mobile-nav-toggle ${isMobileMenuOpen ? "active" : ""}`}
        id="mobile-nav-toggle"
        onClick={toggleMobileNav}
      >
        <span></span>
        <span></span>
        <span></span>
      </div>
      
      <div className="profile-container">
        <div className="profile-wrapper">
          <img
            src={profile}
            alt="Profile"
            className="profile-icon"
            onClick={toggleProfileCard}
          />
          <span className="active-dot"></span>
        </div>

        {isProfileOpen && (
          <div className="profile-card" id="profileCard">
            <img src={profile} alt="Profile" className="profile-card-img" />
            <h4>Mohammed Shoaib</h4>
            <span className="status">ACTIVE - FREELANCER</span>
            <p>Front-End Developer</p>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Header;
